// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UO9b-","col":"styles_col__VeeAL","actions":"styles_actions__7w3K1","conflict":"styles_conflict__1BluV"};